import React, { useState } from 'react';
import { Button, Form, Input } from 'antd';
import TrialSuccess from './TrialSuccess';
const { TextArea } = Input;
const TrialForm = () => {
  const [form] = Form.useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const phoneReg = /^(?:(?:\+|00)86)?1\d{10}$/;
  const emailReg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const onFinish = () => {
    form.validateFields().then((value) => {
      setIsLoading(true);
      const searchParams = new URLSearchParams(window.location.search);
      const source = searchParams.get('source') || 'GW'; // 默认空字符串

      let data = { ...value, source };
      fetch(process.env.REACT_APP_TRIAL_FORM, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...data }),
      })
        .then((response) => response.json())
        .then((res) => {
          setIsLoading(false);
          if (res.error) {
            message.error(res.error.message);
          } else {
            form.setFieldsValue({
              name: null,
              phone: null,
              email: null,
              entName: null,
              businessNeed: null,
            });
            setIsSubmit(true);
            message.success('已收到您的业务需求，我们的业务员会尽快联系您');
          }
        })
        .catch((err) => console.log(err));
    });
  };

  const callBackPageFun = () => {
    setIsSubmit(false);
  };
  const [isComposing, setIsComposing] = useState(false);
  const handleInputChange = (e) => {
    if (!isComposing) {
      const value = e.target.value;
      // 过滤非数字字符
      const numericValue = value.replace(/[^0-9]/g, '');
      form.setFieldsValue({ phone: numericValue });
    }
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = (e) => {
    setIsComposing(false);
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');
    form.setFieldsValue({ phone: numericValue });
  };

  return (
    <div>
      {isSubmit && <TrialSuccess callBackPageFun={callBackPageFun} />}
      {!isSubmit && (
        <div className="trial_TrialBox">
          <div className="trial_TrialBox_title">保理业务系统试用</div>
          <Form
            form={form}
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              name="name"
              label="姓名"
              rules={[
                {
                  required: true,
                  message: '请输入姓名',
                },
              ]}
              style={{ position: 'relative' }}
            >
              <Input maxLength={32} placeholder="请输入姓名" />
            </Form.Item>

            <Form.Item
              label="手机号"
              name="phone"
              rules={[
                { required: true, message: '请输入手机号' },
                {
                  pattern: phoneReg,
                  message: '手机号格式不正确',
                },
              ]}
            >
              <Input
                onChange={handleInputChange}
                onCompositionStart={handleCompositionStart}
                onCompositionEnd={handleCompositionEnd}
                maxLength={11}
                placeholder="请输入手机号"
              />
            </Form.Item>

            <Form.Item
              name="entName"
              label="公司名称"
              rules={[
                {
                  required: true,
                  message: '请输入公司名称',
                },
                {
                  whitespace: true,
                  message: '公司名称不能为空',
                }
              ]}
              style={{ position: 'relative' }}
            >
              <Input maxLength={32} placeholder="请输入公司名称" />
            </Form.Item>

            <Form.Item
              label="邮箱"
              name="email"
              rules={[
                { required: false, message: '请输入邮箱' },
                {
                  pattern: emailReg,
                  message: '邮箱格式不正确',
                },
              ]}
            >
              <Input maxLength={64} placeholder="请输入邮箱" />
            </Form.Item>

            <Form.Item label="业务需求" name="businessNeed">
              <TextArea
                maxLength={200}
                showCount
                placeholder="请输入业务需求"
                style={{ height: 100, resize: 'none' }}
              />
            </Form.Item>

            <Form.Item label={null}>
              <Button
                loading={isLoading}
                className="trial_submit_button"
                style={{ width: '100%' }}
                type="primary"
                htmlType="submit"
              >
                提交
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
    </div>
  );
};
export default TrialForm;
